import React from 'react';
import { Countdown } from './ui/Countdown';
export function UrgencyBar() {
  return <section className="py-8 bg-[#000000]" data-id="element-288">
      <div className="container mx-auto px-4" data-id="element-289">
        <div className="max-w-3xl mx-auto" data-id="element-290">
          <div className="bg-black rounded-3xl p-6 md:p-8 text-center relative overflow-hidden" data-id="element-291">
            <div className="absolute top-0 left-0 w-32 h-32 bg-red-500/15 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-292"></div>
            <div className="absolute bottom-0 right-0 w-32 h-32 bg-red-500/15 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" data-id="element-293"></div>

            <div className="relative z-10" data-id="element-294">
              <div className="inline-block bg-red-500 text-white px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider mb-4" data-id="element-295">
                🔥 Oferta por tiempo limitado 🔥
              </div>

              <h2 className="text-base md:text-lg font-black text-white uppercase tracking-tight mb-5" data-id="element-296">
                El precio de lanzamiento cierra en:
              </h2>

              <div className="rounded-2xl p-4 mb-5 inline-block border border-red-400/30" style={{
              background: 'linear-gradient(135deg, #7f1d1d 0%, #dc2626 50%, #991b1b 100%)'
            }} data-id="element-297">
                <Countdown data-id="element-298" />
              </div>

              <p className="text-red-400 font-black text-xs uppercase tracking-wide" data-id="element-299">
                ⚠️ Después sube a $49.990 ARS — No vuelve
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}